/* eslint-disable import/prefer-default-export */
/**
 * Method to check if token is expired or not
 * @param {String} expiration
 * @returns Boolean
 */
function getDaysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
}
export const isTokenExpired = expiration => {
  const expString = `${expiration.substring(0, 2)}/20${expiration.substring(2, 4)}`;
  const expMonYear = expString.split('/');
  const expDays = getDaysInMonth(expiration.substring(0, 2), expiration.substring(2, 4));
  const expDateString = new Date(expMonYear[1], +expMonYear[0] - 1, expDays);
  const today = new Date();
  if (expDateString > today) {
    return false;
  }
  return true;
};
